import globalToast from "../components/common/globalToast";
import api from "../services/api";

const service_path = "/production-presets.php";

export function getProductionPresets() {
    return api.get(service_path);
}

export function getProductionPresetDetails(id) {
    return api.get(`${service_path}?id=${id}`);
}

export function createProductionPreset(data, navigateBack) {
    api.post(service_path, data)
        .then((response) => {
            const { data: body } = response;
            if (body.success) {
                globalToast.success("Preset cadastrado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(body.message);
            }
        })
        .catch((error) => {
            console.log(error);
            globalToast.error("Houve um erro ao executar essa ação!");
        });
}

export function updateProductionPreset(data, navigateBack) {
    api.patch(service_path, data)
        .then((response) => {
            const { data: body } = response;
            if (body.success) {
                globalToast.success("Preset editado com sucesso!");
                navigateBack();
            } else {
                globalToast.error(body.message);
            }
        })
        .catch((error) => {
            console.log(error);
            globalToast.error("Houve um erro ao executar essa ação!");
        });
}

export function deleteProductionPreset(id) {
    return api.delete(service_path, { data: { id } })
        .then((response) => {
            const { data: body } = response;
            if (body.success) {
                globalToast.success("Preset desativado com sucesso!");
            } else {
                globalToast.error(body.message || "Houve um erro ao desativar esse preset!");
            }
        })
        .catch((error) => {
            globalToast.error(error.response?.data?.message || "Houve um erro ao desativar esse preset!");
            console.log(error);
        });
}
